/**
 * Welcher Chat ist gerade offen? Modulweiter Merker, den die ChatPage setzt und der
 * NotificationContext liest (kein Context nötig, beide hängen nicht voneinander ab).
 *
 * Hintergrund (Code-Review 22.10.2026): Bei offenem Chat unterdrückt das Backend nur
 * den nativen Push. Im Browser kam für jede Nachricht im gerade gelesenen Chat
 * zusätzlich ein Toast mit Inhalt und ein Signalton, und der Chat-Zähler sprang hoch.
 */

let openChatId = null;

/**
 * @param {string|number|null} chatId - der jetzt sichtbare Chat
 * @returns {Function} meldet genau diesen Chat wieder ab (für useEffect-Cleanup)
 */
export const setOpenChat = (chatId) => {
  const id = chatId ? String(chatId) : null;
  openChatId = id;
  return () => {
    if (openChatId === id) openChatId = null;
  };
};

/**
 * true, wenn dieser Chat offen ist und die Seite sichtbar. Bei verdecktem Tab sieht
 * niemand die Nachricht: dann bleiben Toast und Ton als Hinweis.
 */
export const isChatOpen = (chatId) => {
  if (!chatId || !openChatId || openChatId !== String(chatId)) return false;
  return !(typeof document !== 'undefined' && document.hidden);
};
